import {closeDialog, openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {openRepublishInfoDialog} from '../../../components/RepublishInfoDialogContent/utils/openRepublishInfoDialog';
import {CampaignPublishingContent} from '../components/CampaignPublishingContent';

interface OpenRepublishAdsConfirmDialogProps {
  onSelect: (shouldRepublishAds: boolean) => void | Promise<void>;
  isCreating?: boolean;
  onDismiss?: () => void;
}

const REPUBLISH_ADS_CONFIRM_DIALOG_ID = 'campaignPublishingConfirmDialog';

export function openRepublishAdsConfirmDialog(props: OpenRepublishAdsConfirmDialogProps) {
  return new Promise<void>((resolve) => {
    let hasOptionSelected = false;

    const handleSelect = (shouldRepublishAds: boolean) => {
      hasOptionSelected = true;
      closeDialog(REPUBLISH_ADS_CONFIRM_DIALOG_ID);

      if (shouldRepublishAds) {
        openRepublishInfoDialog({onCloseComplete: () => resolve(props.onSelect(true))});
        return;
      }

      resolve(props.onSelect(false));
    };

    openDialog(
      <CampaignPublishingContent isCreating={props.isCreating} onSelect={handleSelect} />,
      {
        id: REPUBLISH_ADS_CONFIRM_DIALOG_ID,
        title: props.isCreating
          ? i18n.t('entity.salesCampaign.publishDialog.title')
          : i18n.t('entity.salesCampaign.republishDialog.title'),
        'data-testid': REPUBLISH_ADS_CONFIRM_DIALOG_ID,
        onCloseComplete: () => {
          if (!hasOptionSelected) {
            props.onDismiss?.();
            resolve();
          }
        },
      }
    );
  });
}
